
export default {
  orders: [],
  order: {},
  messageSearchQuery:""
}
